import { cn } from "@/lib/utils";

const TONES = {
  gray: "bg-gray-500/10 text-gray-600 border-gray-500/20 dark:text-gray-400",
  red: "bg-red-500/10 text-red-600 border-red-500/20 dark:text-red-400",
  amber: "bg-amber-500/10 text-amber-600 border-amber-500/20 dark:text-amber-400",
  orange: "bg-orange-500/10 text-orange-600 border-orange-500/20 dark:text-orange-400",
  yellow: "bg-yellow-500/10 text-yellow-600 border-yellow-500/20 dark:text-yellow-400",
  green: "bg-green-500/10 text-green-600 border-green-500/20 dark:text-green-400",
  emerald: "bg-emerald-500/10 text-emerald-600 border-emerald-500/20 dark:text-emerald-400",
  teal: "bg-teal-500/10 text-teal-600 border-teal-500/20 dark:text-teal-400",
  blue: "bg-blue-500/10 text-blue-600 border-blue-500/20 dark:text-blue-400",
  indigo: "bg-indigo-500/10 text-indigo-600 border-indigo-500/20 dark:text-indigo-400",
  purple: "bg-purple-500/10 text-purple-600 border-purple-500/20 dark:text-purple-400",
  pink: "bg-pink-500/10 text-pink-600 border-pink-500/20 dark:text-pink-400",
  sky: "bg-sky-500/10 text-sky-600 border-sky-500/20 dark:text-sky-400",
  rose: "bg-rose-500/10 text-rose-600 border-rose-500/20 dark:text-rose-400",
  violet: "bg-violet-500/10 text-violet-600 border-violet-500/20 dark:text-violet-400",
  slate: "bg-slate-500/10 text-slate-600 border-slate-500/20 dark:text-slate-400",
};
export const DOTS = {
  gray: "bg-gray-500", red: "bg-red-500", amber: "bg-amber-500", orange: "bg-orange-500", yellow: "bg-yellow-500",
  green: "bg-green-500", emerald: "bg-emerald-500", teal: "bg-teal-500", blue: "bg-blue-500", indigo: "bg-indigo-500",
  purple: "bg-purple-500", pink: "bg-pink-500", slate: "bg-slate-500", sky: "bg-sky-500", rose: "bg-rose-500", violet: "bg-violet-500",
};
const SIZES = { xs: "text-[10px] px-1.5 py-0", sm: "text-xs px-2 py-0.5", md: "text-sm px-2.5 py-0.5" };

export const StatusBadge = ({ colour = "gray", size = "sm", dot = false, width, className, children, testId }) => (
  <span
    data-testid={testId}
    style={width ? { minWidth: width } : undefined}
    className={cn(
      "inline-flex max-w-full items-center justify-center gap-1.5 overflow-hidden rounded-sm border font-medium whitespace-nowrap",
      TONES[colour] || TONES.gray,
      SIZES[size],
      className
    )}
  >
    {dot && <span className={cn("h-1.5 w-1.5 rounded-full", DOTS[colour] || DOTS.gray)} />}
    {children}
  </span>
);

const STAT_TONES = {
  mono: "bg-muted text-muted-foreground",
  success: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  warning: "bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400",
  danger: "bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400",
  info: "bg-blue-100 text-blue-700 dark:bg-blue-950/40 dark:text-blue-400",
};

export const StatIcon = ({ icon: Icon, tone = "mono" }) => (
  <div className={cn("flex h-9 w-9 items-center justify-center rounded-sm", STAT_TONES[tone])}>
    <Icon className="h-4 w-4" />
  </div>
);

export const StatTile = ({ icon, tone, label, value, hint, valueClass, testId }) => (
  <div className="metric-card" data-testid={testId}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
        <p className={cn("text-2xl font-bold tracking-tighter mt-1", valueClass)} data-testid={testId && `${testId}-value`}>
          {value}
        </p>
      </div>
      <StatIcon icon={icon} tone={tone} />
    </div>
    {hint && <p className="text-xs text-muted-foreground mt-2">{hint}</p>}
  </div>
);

export const TestBadge = ({ testId }) => (
  <span className="mr-1 inline-flex items-center rounded-sm bg-amber-400 px-1.5 py-px text-[10px] font-bold uppercase tracking-wide text-black align-middle" title="Test data – remove from Admin → System → Test data" data-testid={testId}>TEST</span>
);
